import React, { ReactElement } from 'react';
import PngTemplateArt from './PngTemplateArt';
import circlesOfControlImage from '../assets/circles-of-control.png';

interface CirclesOfControlArtProps {
  isDarkMode: boolean;
}

export default function CirclesOfControlArt({ isDarkMode }: CirclesOfControlArtProps): ReactElement {
  return <PngTemplateArt src={circlesOfControlImage} isDarkMode={isDarkMode} />;
}
